module.exports = __webpack_public_path__ + "partie-2.gif?b2045aa013fb1a4a8b3c0678b6331d16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partie-2.gif
// module id = 159
// module chunks = 0